var React = require('react');

function IcError2 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("circle",{"id":"a","cx":"17.5","cy":"17.5","r":"17.5"})),React.createElement("clipPath",{"id":"b","key":1},React.createElement("use",{"xlinkHref":"#a","overflow":"visible"})),React.createElement("path",{"d":"M19.5 20.1h-4V6.9h4v13.2zm0 7h-4v-3.5h4v3.5z","clipPath":"url(#b)","key":2})]);
}

IcError2.defaultProps = {"viewBox":"0 0 35 35"};

module.exports = IcError2;

IcError2.default = IcError2;
